import React from 'react'
import {connect} from 'react-redux';
import {
    Modal,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Row,
    Col,
} from "reactstrap";
const SendFile = ({getTemplate, handleSubmitFile, currentUser}) => {
    const [UploadedFile, setUploadedFile] = React.useState({
        name: 'Wgraj plik excel z danymi',
        file: null
    });
    const handleFileInput = (file) => {
        setUploadedFile({
            name: file.name,
            file: file
        });
    };
    return (
        <div >
            <Form>
                <FormGroup className='wycenaFile'>
                    <Input style={{cursor:"pointer"}} className='wycenaFile'
                        type="file"
                        id="import-excel"
                        name="excelFile"
                        label={`${UploadedFile.name}`}
                        lang="pl"
                        onChange={(e) => handleFileInput(e.target.files[0])}
                        disabled={currentUser && currentUser.company ===null }
                    />
                    <Label for="import-excel" className='custom-file-label'>{UploadedFile.name}</Label>

                </FormGroup>
                <Row>
                    <Col xs="6">
                        <Button style={{width: '230px'}}
                            className="btn-round m-0" color="wycena" outline type="button"
                            // block className={'btn-aotmit-gradient-reverse m-0'} 
                            onClick={e=>{getTemplate()}}
                            >
                            <i className="fas fa-download mr-2"/>
                            Pobierz szablon pliku
                        </Button>
                    </Col>
                    <Col className="text-right"  xs="6">
                        <Button type='button' style={{width: '230px'}}
                            onClick={(e) => {handleSubmitFile(UploadedFile)
                                setUploadedFile({
                                    name: 'Wgraj plik excel z danymi',
                                    file: null
                                })
                                ;}}
                            // block className={'btn-aotmit-gradient m-0'}
                            className="btn-round m-0" color="wycena" outline>
                            <i className="fas fa-upload mr-2"/>
                            Prześlij plik
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default SendFile